import React from 'react';
import Carousel from '../_shared/Carousel/Carousel';
import HeroSection from '../_shared/HeroSection/HeroSection';
import About from '../_shared/AboutSection/About';
import SEO from '../SEO';
import { useLanguage } from '../../i18n';

const Home = () => {
  const { t } = useLanguage();

  return (
    <div className="home-container">
      <SEO
        title={t('seo.homeTitle')}
        description={t('seo.homeDescription')}
        url="https://fixanor.com"
        image="https://fixanor.com/images/hero-image-webp.webp"
      />
   
      <HeroSection />
      <div style={styles.main}>
        <About/>
        <Carousel />
      </div>
      
    </div>
  );
};

const styles = {
  main: {
    backgroundColor: 'var(--color-bg)',
    width: '100%',
    minHeight: '100vh', 
    padding: '2rem 0',  
  }
};

export default Home;
